import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Input, Button, Form, Tabs, Checkbox, message } from "antd";
import { useDispatch } from "react-redux";
import VerifyCodeBtn from "@/components/VerifyCodeBtn";

import { publicPath } from "@/utils/base";
import { passwordReg, phoneReg } from "@/utils/constant";
import { hmacSHA256 } from "@/utils";

import "./index.less";

import api from "@/api";
import dataJson from "@/../public/data.json";
import PrivacyModel, { useModal } from "@/components/GetAccount/components/privacyModel";
import { clearX86DeveloperLoginIntent } from "@/utils/desktopDownloadReport";


const prefix = "login";
const INPUT_HEIGHT = 56;

const Login: React.FC = () => {
  const { and, login, account, req_err } = dataJson;

  const [codeData, setCodeData] = useState<any>({});
  const [isPhoneValueOk, setIsPhoneValueOk] = useState(false);

  const [accountForm] = Form.useForm();
  const [phoneForm] = Form.useForm();
  const phoneValue = Form.useWatch("receiver", phoneForm);

  const navigate: any = useNavigate();
  const [getSearchArr] = useSearchParams();
  const dispatch = useDispatch();

  const { isShowContract, fileType, viewContract, setIsShowContract } = useModal();

  // const beforeClick = async (cb: any) => {
  //   const resp: any = await api.checkPhone({ receiver: phoneValue });
  //   if (resp.code === 200 && resp.data === true) {
  //     cb();
  //   } else {
  //     window.message.error("该手机号未注册");
  //   }
  // };

  const loginFnc = (res: any) => {
    // 登录成功
    if (res.code === 200) {
      clearX86DeveloperLoginIntent();
      dispatch({
        type: "setPortalAuthorization",
        payload: { accessToken: res.data.accessToken || "", expireTime: res.data.expireTime },
      });
      const jump_url = getSearchArr.getAll("jump_url");
      if (jump_url?.length) {
        let result = jump_url[0];
        if (result?.indexOf(window.location.origin) === -1) {
          // 非同源
          result =
            jump_url[0].indexOf("?") >= 0
              ? `${jump_url[0]}&token=${res.data.accessToken || ""}`
              : `${jump_url[0]}?token=${res.data.accessToken || ""}`;
        }

        window.open(
          result,
          "_self",
          "toolbar=yes, menubar=yes, scrollbars=yes, resizable=yes, location=yes, status=yes"
        );
      } else {
        navigate(publicPath);
      }
    } else {
      window.message.error(res.msg || req_err);
    }
  };
  // 登录
  const accountFormFinish = async (values: any) => {
    const res: any = await api.systemLogin({
      ...values,
    });
    if (res.code === 200) {
      loginFnc(res);
    } else if (res?.data?.lock) {
      // 5次错误账号被锁
      const resData = res?.data;
      const m = Math.trunc(resData?.lockedTime / 60000);
      const s = Math.trunc((resData?.lockedTime - m * 60000) / 1000);
      window.message.error(`账号或密码错误，请${m > 0 ? m + "分钟" : ""}${s}秒后再试。`);
    } else {
      // 登录失败
      window.message.error("账号或密码不正确");
    }
  };

  const phoneFormFinish = async (values: any) => {
    const res: any = await api.smsLogin({
      receiver: phoneValue,
      validate: {
        code: values?.code,
        type: codeData?.type,
        function: codeData?.function,
        token: hmacSHA256(codeData?.token, codeData?.secret),
      },
    });
    if (res.code === 200) {
      loginFnc(res);
    } else {
      // 登录失败
      window.message.error("登录失败，账号或验证码不正确");
    }
  };

  const setPhoneCode = (params: any) => {
    setCodeData(params);
  };

  const FormItem = () => {
    return (
      <>
        <Form.Item
          name="agree"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error(account.check_agreement))),
            },
          ]}
        >
          <Checkbox>
            {account.read_accepted}
            <Button type="link" style={{ padding: "0 2px", height: "19px" }} onClick={() => viewContract("privacy")}>
              {account.privacy_olicy}
            </Button>
            {and}
            <Button type="link" style={{ padding: "0 2px", height: "19px" }} onClick={() => viewContract("user")}>
              {account.user_agreement}
            </Button>
          </Checkbox>
        </Form.Item>

        <Form.Item>
          <Button type="primary" size="large" htmlType="submit" style={{ height: INPUT_HEIGHT }} block>
            {login.login_text}
          </Button>
        </Form.Item>
      </>
    );
  };

  useEffect(() => {
    phoneValue &&
      phoneForm.validateFields(["receiver"]).then(
        () => {
          setIsPhoneValueOk(true);
        },
        () => {
          setIsPhoneValueOk(false);
        }
      );
  }, [phoneValue]);

  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-bg`}>
        <img src={login.login_bg_img} alt="" />
      </div>
      <div className={`${prefix}-box`}>
        <Tabs
          defaultActiveKey="1"
          className={`${prefix}-tabs`}
          items={[
            {
              label: login.message_login,
              key: "1",
              children: (
                <Form
                  className={`${prefix}-form`}
                  form={phoneForm}
                  wrapperCol={{ span: 24 }}
                  initialValues={{ remember: true }}
                  onFinish={phoneFormFinish}
                  autoComplete="off"
                >
                  <Form.Item
                    name="receiver"
                    rules={[
                      { required: true, message: account.phone_number_placeholder },
                      {
                        pattern: phoneReg,
                        message: account.phone_number_message,
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      placeholder={account.phone_number_placeholder}
                      style={{ height: INPUT_HEIGHT }}
                    />
                  </Form.Item>
                  <div className={`${prefix}-code`}>
                    <Form.Item name="code" rules={[{ required: true, message: account.code_placeholder }]}>
                      <Input
                        size="large"
                        placeholder={account.code_placeholder}
                        style={{ width: 216, height: INPUT_HEIGHT }}
                      />
                    </Form.Item>
                    <VerifyCodeBtn
                      phoneNumber={isPhoneValueOk ? phoneValue : ""}
                      apiFnc={api.getCodeSmsLogin}
                      reload={setPhoneCode}
                      beforeClick={true}
                    />
                  </div>

                  <FormItem></FormItem>
                </Form>
              ),
            },
            {
              label: login.account_login,
              key: "2",
              children: (
                <Form
                  className={`${prefix}-form`}
                  form={accountForm}
                  initialValues={{ remember: true }}
                  onFinish={accountFormFinish}
                  autoComplete="off"
                >
                  <Form.Item name="userName" rules={[{ required: true, message: login.account_username_message }]}>
                    <Input
                      size="large"
                      placeholder={login.account_username_placeholder}
                      style={{ height: INPUT_HEIGHT }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      { required: true, message: login.account_password_message },
                      {
                        pattern: passwordReg,
                        message: login.account_password_validate,
                      },
                    ]}
                  >
                    <Input.Password
                      size="large"
                      placeholder={login.account_password_placeholder}
                      style={{ height: INPUT_HEIGHT }}
                    />
                  </Form.Item>

                  <FormItem></FormItem>
                </Form>
              ),
            },
            
          ]}
        />

        <div className={`${prefix}-footer`}>
          <Button type="link" href={`${publicPath}register_account`}>
            {login.quick_register}
          </Button>
          <Button type="link" href={`${publicPath}forgot_password`}>
            {account.forgot_password}
          </Button>
        </div>
        <PrivacyModel
          fileType={fileType}
          open={isShowContract}
          onOk={() => {
            setIsShowContract(false);
          }}
          onCancel={() => {
            setIsShowContract(false);
          }}
        />
      </div>
    </div>
  );
};

export default Login;
